<div class="modal-overlay">
  <div class="modal-content relative">
    <h2>Select an Option</h2>
    <button type="button" class="btn-submit" id="submit-option-btn" (click)="onSubmit()">Submit</button>
    <button type="button" class="btn-export" id="export-pdf-btn" (click)="onSubmitAndCreatePdf()">
      <div class="flex">
        Submit & Export as PDF
      </div>
    </button>

    <button (click)="closeModal()" id="close-modal-btn" class="absolute top-2 right-2 text-gray-600 hover:text-gray-800">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>
</div>
